/**
 * Connector version this machine is offered, for the in-app update banner.
 * Primary: connector-latest-tag (fleet tag, or the staged-rollout tag for canary machines).
 * Fallback: latest.json (Tauri updater manifest). Inside the Connector both carry
 * machine_id_hash (same hash the Rust check sends); a plain browser sends none.
 */
import { CLOUD_API_URL } from '../config/serverConfig';
import { getConnectorMachineIdHash } from './connectorMachineIdHash';

function normalizeVersion(raw: unknown): string | null {
  const tag = String(raw ?? '').trim();
  if (!tag) return null;
  return tag.replace(/^v/i, '');
}

async function fetchVersion(path: string, hash: string | null): Promise<string | null> {
  const q = hash ? `&machine_id_hash=${encodeURIComponent(hash)}` : '';
  const res = await fetch(`${CLOUD_API_URL}${path}?_=${Date.now()}${q}`, { credentials: 'omit' });
  if (!res.ok) return null;
  const data = await res.json() as { tag?: string; version?: string };
  return normalizeVersion(data?.tag ?? data?.version);
}

export async function fetchConnectorLatestPublishedVersion(
  opts: { machineIdHash?: string | null } = {},
): Promise<string | null> {
  const hash = opts.machineIdHash !== undefined ? opts.machineIdHash : await getConnectorMachineIdHash();
  try {
    const fromKv = await fetchVersion('/api/config/connector-latest-tag', hash);
    if (fromKv) return fromKv;
  } catch { /* KV endpoint optional until Mycelium deploy */ }
  try {
    return await fetchVersion('/api/maestro/updates/latest.json', hash);
  } catch { /* ignore */ }
  return null;
}
